module.exports = __webpack_public_path__ + "img/108.partial_Information.621ae214.svg";